import { useMemo } from 'react';
import { useAuth } from '@clerk/react';
import {
  isLinkedInAccount,
  useListEmailAccountsQuery,
} from '@/store/features/engage.feature';

/**
 * The connected accounts, split by channel. LinkedIn accounts come back from
 * the same list, so every email-sender picker reads `email`, never the raw list.
 */
export function useSenderAccounts({ skip = false }: { skip?: boolean } = {}) {
  const { orgId, userId } = useAuth();
  const query = useListEmailAccountsQuery(
    { organizationId: orgId ?? undefined, userId: userId ?? undefined },
    { skip: skip || !orgId || !userId }
  );
  const [email, linkedin] = useMemo(() => {
    const all = query.currentData ?? [];
    return [
      all.filter((account) => !isLinkedInAccount(account)),
      all.filter(isLinkedInAccount),
    ];
  }, [query.currentData]);
  return { ...query, data: query.currentData, email, linkedin };
}
